import React from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import palette from 'src/theme/palette';

import { previewStartReq } from '../constants';
import {
  PreviewPromtButton,
  PreviewText,
  PreviewTextBlock,
  PreviewWrapper,
} from '../styled';

export const Preview = ({
  onChangePreviewButtonClick,
}: {
  onChangePreviewButtonClick: (text: string, queries?: string[]) => void;
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <PreviewWrapper>
      <Box>
        <Typography
          className="title"
          fontWeight={700}
          fontSize="48px"
          lineHeight="63px"
          color={palette.primary.main}
        >
          Kipify
        </Typography>
      </Box>
      <Box display="flex" flexDirection="column" alignItems="center">
        <Typography
          className="description"
          fontWeight={500}
          fontSize="24px"
          lineHeight="31px"
          textAlign="center"
        >
          Ready to Elevate Your Business?
          {!isSmallScreen ? <br /> : ' '}
          Unlock Your Potential with Our AI Consultant!
        </Typography>
      </Box>
      <Box
        className="label"
        display="flex"
        padding="3px 10px"
        borderRadius="4px"
        bgcolor={palette.primary.light}
      >
        <Typography
          fontWeight={700}
          fontSize="10px"
          lineHeight="13px"
          color={palette.secondary.light}
        >
          {'Multi-LLM Powered'.toLocaleUpperCase()}
        </Typography>
      </Box>
      <PreviewTextBlock>
        {previewStartReq.map((pr) => {
          return (
            <PreviewPromtButton
              key={pr.id}
              onClick={() =>
                onChangePreviewButtonClick(
                  pr.text,
                  (pr as any).isMultiQuery ? (pr as any).queries : undefined,
                )
              }
            >
              <PreviewText>{pr.text}</PreviewText>
            </PreviewPromtButton>
          );
        })}
      </PreviewTextBlock>
    </PreviewWrapper>
  );
};
